import { memo } from 'react'
import { Link } from 'react-router-dom'
import {
  Button,
} from '@panwds/react-ui'
import { getFrameworkVar } from '@sparky/framework'
import { showActivate, RUNNING, showUnifiedActivation } from '../../utils/common'
import type { FC, VFC } from 'react'
import type { AppWithOptionalInstance } from '../../types'

export const ALink: FC<{ to: string, className?: string, dataTestId?: string }> = ({ children, to, className, dataTestId }) => (to.startsWith('https:') ?
  <a className={className} href={to} data-testid={dataTestId}>{children}</a> :
  <Link className={className} to={to} data-testid={dataTestId}>{children}</Link>
)

const PrimaryButtonComp: VFC<AppWithOptionalInstance> = ({ app, instance }) => {
  if (instance?.url && instance.status === RUNNING && !instance.extra?.hidden && !instance.runtime_attributes?.hidden) {
    return (
      <ALink
        className='sparky-hub-app-tile-btn'
        to={instance.app_launch_url_override || instance.url}
        dataTestId={`hub-launch-btn:${instance.tsg_id}:${instance.app_id}:${instance.tenant_id}`}
      >
        <Button appearance='primary' size='md'>
          Launch
        </Button>
      </ALink>
    )
  }
  else if (instance) {
    return null // no button for not ready one
  }
  const shouldShowBtn = app.is_third_party ? (
    app.activatable !== false && getFrameworkVar<boolean>('third_party_activate') !== false
  ) : (
    app.activatable && !app.has_auth_code && !app.is_fake &&
    !app.flags?.use_license_hash_only
  )
  if (shouldShowBtn) {
    return <Button appearance='secondary' size='md' addClassName='sparky-hub-app-tile-btn' onClick={() => {
      app?.setup?.unified_activation_path ? showUnifiedActivation(app.setup.unified_activation_path) : showActivate(app.app_id)
    }} dataTestId={`hub-activate-btn:${app.app_id}`}>Activate</Button>
  }
  return null
}
export const PrimaryButton = memo(PrimaryButtonComp)
